var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNorecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624496",
    x: 11,
    y: 6,
    width: 32,
    height: 34,
    fill: "url(#paint0_linear_1011_19237)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 194",
    cx: 12.5,
    cy: 31.5,
    r: 7.5,
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.3335 42.1666H15.3335C14.743 42.1708 14.1558 42.0791 13.5946 41.8952C13.1173 41.7301 12.7244 41.3834 12.5014 40.9303C12.2783 40.4772 12.2431 39.9543 12.4034 39.4754C12.5637 38.9965 12.9066 38.6002 13.3574 38.3726C13.8083 38.1451 14.3308 38.1047 14.8113 38.2602C14.9804 38.3121 15.1567 38.3367 15.3335 38.3333H38.3335C38.8417 38.3327 39.3289 38.1306 39.6882 37.7713C40.0476 37.412 40.2497 36.9248 40.2502 36.4166V9.58325C40.2497 9.07508 40.0476 8.58786 39.6882 8.22852C39.3289 7.86919 38.8417 7.66709 38.3335 7.66659H15.3335C14.8253 7.66709 14.3381 7.86919 13.9788 8.22852C13.6194 8.58786 13.4173 9.07508 13.4168 9.58325V23.057C13.4168 23.5653 13.2149 24.0529 12.8555 24.4123C12.496 24.7717 12.0085 24.9737 11.5002 24.9737C10.9918 24.9737 10.5043 24.7717 10.1449 24.4123C9.78543 24.0529 9.5835 23.5653 9.5835 23.057V9.58325C9.58516 8.05877 10.1915 6.5972 11.2695 5.51923C12.3474 4.44125 13.809 3.83492 15.3335 3.83325H38.3335C39.858 3.83492 41.3195 4.44125 42.3975 5.51923C43.4755 6.5972 44.0818 8.05877 44.0835 9.58325V36.4166C44.0818 37.9411 43.4755 39.4026 42.3975 40.4806C41.3195 41.5586 39.858 42.1649 38.3335 42.1666Z",
    fill: "url(#paint1_linear_1011_19237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4582 42.1666C10.3732 42.1666 8.33511 41.5483 6.60154 40.39C4.86797 39.2317 3.51682 37.5853 2.71895 35.659C1.92107 33.7328 1.71231 31.6132 2.11906 29.5683C2.52582 27.5235 3.52981 25.6451 5.00409 24.1708C6.47837 22.6966 8.35672 21.6926 10.4016 21.2858C12.4465 20.8791 14.5661 21.0878 16.4923 21.8857C18.4185 22.6836 20.0649 24.0347 21.2233 25.7683C22.3816 27.5019 22.9998 29.54 22.9998 31.6249C22.9965 34.4197 21.8848 37.0991 19.9086 39.0753C17.9324 41.0516 15.253 42.1633 12.4582 42.1666ZM12.4582 24.9166C11.1314 24.9166 9.8344 25.31 8.73123 26.0471C7.62805 26.7843 6.76822 27.832 6.26048 29.0578C5.75275 30.2835 5.6199 31.6324 5.87874 32.9337C6.13758 34.2349 6.77649 35.4303 7.71467 36.3684C8.65284 37.3066 9.84816 37.9455 11.1494 38.2044C12.4507 38.4632 13.7996 38.3304 15.0253 37.8226C16.2511 37.3149 17.2988 36.4551 18.036 35.3519C18.7731 34.2487 19.1665 32.9517 19.1665 31.6249C19.1644 29.8464 18.4569 28.1414 17.1993 26.8838C15.9417 25.6262 14.2367 24.9187 12.4582 24.9166Z",
    fill: "url(#paint2_linear_1011_19237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1858 36.9914C13.8295 36.9917 13.4802 36.8928 13.177 36.7057C12.8738 36.5185 12.6288 36.2506 12.4694 35.932L10.7437 32.4823C10.6107 32.2161 10.5415 31.9226 10.5415 31.6251V28.1755C10.5415 27.6671 10.7434 27.1796 11.1029 26.8202C11.4623 26.4607 11.9498 26.2588 12.4582 26.2588C12.9665 26.2588 13.454 26.4607 13.8135 26.8202C14.1729 27.1796 14.3748 27.6671 14.3748 28.1755V31.1721L15.8984 34.2174C16.0446 34.5095 16.1136 34.8341 16.099 35.1604C16.0845 35.4867 15.9868 35.8038 15.8152 36.0817C15.6436 36.3596 15.4039 36.589 15.1187 36.7482C14.8335 36.9074 14.5124 36.9911 14.1858 36.9914Z",
    fill: "url(#paint3_linear_1011_19237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.4168 17.2501H17.2502C16.7418 17.2501 16.2543 17.0481 15.8949 16.6887C15.5354 16.3293 15.3335 15.8417 15.3335 15.3334C15.3335 14.8251 15.5354 14.3376 15.8949 13.9781C16.2543 13.6187 16.7418 13.4167 17.2502 13.4167H36.4168C36.9252 13.4167 37.4127 13.6187 37.7721 13.9781C38.1316 14.3376 38.3335 14.8251 38.3335 15.3334C38.3335 15.8417 38.1316 16.3293 37.7721 16.6887C37.4127 17.0481 36.9252 17.2501 36.4168 17.2501Z",
    fill: "#181A1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.4167 23.9583H24.9167C24.4083 23.9583 23.9208 23.7564 23.5614 23.397C23.2019 23.0375 23 22.55 23 22.0417C23 21.5333 23.2019 21.0458 23.5614 20.6864C23.9208 20.3269 24.4083 20.125 24.9167 20.125H36.4167C36.925 20.125 37.4125 20.3269 37.772 20.6864C38.1314 21.0458 38.3333 21.5333 38.3333 22.0417C38.3333 22.55 38.1314 23.0375 37.772 23.397C37.4125 23.7564 36.925 23.9583 36.4167 23.9583Z",
    fill: "#181A1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.4165 30.6666H29.7082C29.1998 30.6666 28.7123 30.4647 28.3529 30.1052C27.9934 29.7458 27.7915 29.2583 27.7915 28.7499C27.7915 28.2416 27.9934 27.7541 28.3529 27.3946C28.7123 27.0352 29.1998 26.8333 29.7082 26.8333H36.4165C36.9248 26.8333 37.4123 27.0352 37.7718 27.3946C38.1312 27.7541 38.3332 28.2416 38.3332 28.7499C38.3332 29.2583 38.1312 29.7458 37.7718 30.1052C37.4123 30.4647 36.9248 30.6666 36.4165 30.6666Z",
    fill: "#181A1E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19237",
    x1: 11,
    y1: 23.2464,
    x2: 43,
    y2: 23.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1011_19237",
    x1: 9.5835,
    y1: 23.2778,
    x2: 44.0835,
    y2: 23.2778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1011_19237",
    x1: 1.9165,
    y1: 31.7777,
    x2: 22.9998,
    y2: 31.7777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1011_19237",
    x1: 10.5415,
    y1: 31.7028,
    x2: 16.101,
    y2: 31.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNorecord);
export default __webpack_public_path__ + "static/media/icon_norecord.2ce2b45c7c37c56932f23029eb646149.svg";
export { ForwardRef as ReactComponent };